import { createI18n } from 'vue-i18n'
import en from './locales/en'
import { DEFAULT_LOCALE } from './locales'

/**
 * en-US ships in the bundle; every other locale is loaded from the API on
 * demand by locale-loader.ts and registered with `setLocaleMessage`. The
 * fallback is what makes a partial translation safe: a missing key renders
 * the English string, never the key.
 */
export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { [DEFAULT_LOCALE]: en },
  // A missing key in ENGLISH is a bug and should be loud in development. A
  // missing key in another locale is expected — that is what the fallback is for.
  missingWarn: false,
  fallbackWarn: false,
})
